import { getGridStringOperators } from "@mui/x-data-grid";

// Shared DataGrid defaults for the RGM table previews (input variant preview
// and cockpit scenario board) so filtering, search, pagination and sorting
// behave and look the same in both.

// Filter operators offered in every preview. The input variant preview
// executes these server-side (see backend TableDataView._build_filter); the
// scenario board filters client-side but exposes the same set for parity.
export const SUPPORTED_FILTER_OPS = [
  "contains",
  "equals",
  "startsWith",
  "endsWith",
  "isEmpty",
  "isNotEmpty",
];

export const TABLE_FILTER_OPERATORS = getGridStringOperators().filter((op) =>
  SUPPORTED_FILTER_OPS.includes(op.value),
);

export const TABLE_PAGE_SIZE_OPTIONS = [25, 50, 100];

// Shared filter-panel styling (slotProps.filterPanel) for both preview grids:
// uniform small outlined inputs so the row aligns, and neutral focus colors —
// the theme defaults (violet label / blue outline) clash with the app's look
// and only became visible once the panel inputs could actually hold focus.
export const TABLE_FILTER_PANEL_PROPS = {
  filterFormProps: {
    columnInputProps: {
      variant: "outlined",
      size: "small",
      sx: { mt: "auto" },
    },
    operatorInputProps: {
      variant: "outlined",
      size: "small",
      sx: { mt: "auto" },
    },
    valueInputProps: {
      InputComponentProps: { variant: "outlined", size: "small" },
    },
    deleteIconProps: {
      sx: { "& .MuiSvgIcon-root": { color: "#2b2f33" } },
    },
  },
  sx: {
    "& .MuiDataGrid-filterForm": { p: 1.5, gap: 1, alignItems: "center" },
    "& .MuiDataGrid-filterFormColumnInput": { width: 170 },
    "& .MuiDataGrid-filterFormOperatorInput": { width: 140 },
    "& .MuiDataGrid-filterFormValueInput": { width: 190 },
    "& .MuiInputLabel-root.Mui-focused": { color: "#2b2f33" },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#2b2f33",
    },
  },
};
